import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { FaBusinessTime, FaDownload, FaEye, FaEyeSlash, FaTrash, FaUsers } from 'react-icons/fa'
import { getStatusAH, IArquiteturaHumana, IArquiteturaHumanaParticipante } from '../..'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { ModalDelete } from '../../../../components/ModalDelete'
import { appApi } from '../../../../services/appApi'
import { CardColaboradorSi } from '../../../AssessmentPI/components/TabelaAderencia/components/cardColabSI'

interface iProps{
  arquiteturaHumana: IArquiteturaHumana
  handleSelect: (selected: IArquiteturaHumanaParticipante) => void
}
export const CardAH: React.FC<iProps> = ({ arquiteturaHumana, handleSelect }) => {
  function verificaSelecao(userId: string): boolean {
    return arquiteturaHumana.participantes.some((pessoa) => pessoa.assessmentUserId === userId)
  }
  function ExcluirAH(id: string): void {
    appApi.delete(`api/AH/Excluir/${id}`).then(e => console.log('sucesso')).catch(e => console.log('Erro'))
  }

  async function BaixarCSV(id: string, empresa: string): Promise<void> {
    try {
    // Faz a requisição e recebe o arquivo como blob
      const response = await appApi.get(`api/AH/${id}/CSV`, {
        responseType: 'blob' // importante!
      })

      const fileName = `ArquiteturaHumana_${empresa.replace(/ /g, '_')}.csv`

      // Cria uma URL temporária para o arquivo
      const url = window.URL.createObjectURL(new Blob([response.data]))

      // Cria um link temporário <a> para disparar o download
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName) // nome do arquivo
      document.body.appendChild(link)
      link.click()

      // Remove o link e libera a URL
      link.parentNode?.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error)
    }
  }
  // function EditarAH(id: string): void {
  // //  appApi.delete(`api/AH/Exlcuir/${id}`).then(e => console.log('sucesso')).catch(e => console.log('Erro'))
  // }
  function onCloseModalDelete(): void {
    setModalDeleteIsOpen(false)
  }
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [ocultarLista, setOcultarLista] = useState(true)
  const [IdAHEditDel, setIdAHEditDel] = useState('')

  return (<Box bgColor={'gray.100'} rounded={'lg'} padding='1rem'>
     <ModalDelete
        isOpen={ModalDeleteIsOpen}
        message='Deseja realmente excluir esta pesquisa?'
        onRequestClose={() => onCloseModalDelete()}
        onConfirm={() => { ExcluirAH(IdAHEditDel) }}
      />
<Flex flexDir={'column'}>

<Flex justifyContent={'space-between'}>
    <Flex gap={'2rem'}>
      <Text><FaBusinessTime/> Empresa: {arquiteturaHumana.empresa}</Text>
      <Text>Status: {getStatusAH(arquiteturaHumana.status)}</Text>
      </Flex>
      <Flex gap={'1.2rem'}>
      { arquiteturaHumana.status === 1 && (<ElementoTooltipCmp label={'Clique para baixar a planilha .CSV' } bg={'gray.500'}><Button size={'sm'} backgroundColor={'var(--Azul)'}
      onClick={async () => await BaixarCSV(arquiteturaHumana.id, arquiteturaHumana.empresa)}><FaDownload/></Button></ElementoTooltipCmp>)}
      <ElementoTooltipCmp label={'Excluir Arquitetura Humana' } bg={'var(--Red)'}>

      <Button size={'sm'} backgroundColor={'var(--Red)'}
      onClick={() => { setIdAHEditDel(arquiteturaHumana.id); setModalDeleteIsOpen(true) }}><FaTrash/></Button>
      </ElementoTooltipCmp>
    </Flex>
    </Flex>

    <Text fontWeight={'medium'} my='0.5rem' color='var(--Rosa)'><FaUsers/> Participantes: {arquiteturaHumana.participantes.length}</Text>
     {arquiteturaHumana.participantes.length > 0 && <Button mx='.7rem' size={'xs'} backgroundColor={'var(--Rosa)'} leftIcon={ocultarLista ? <FaEye/> : <FaEyeSlash/>}
        onClick={() => setOcultarLista(!ocultarLista)}> {ocultarLista ? 'Exibir' : 'Ocultar'} lista
      </Button>
      }

      {!ocultarLista && arquiteturaHumana.participantes.length > 0 && <Flex
   flexDirection={'column'}
   border={'1px'} p={'0.5rem'} overflow={'auto'}
   m={'.7rem'}
    height='300px'
    borderColor='blue.200'
    bgColor={'whiteAlpha.600'}
    gap={'4px'}
    >
    {!ocultarLista && arquiteturaHumana.participantes.map((j, i) =>
                    <CardColaboradorSi
                    compacto
                      perfil={j}
                      selecionado={verificaSelecao(j.assessmentUserId)}
                      onSelect={() => {
                        handleSelect(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
    )}
                  </Flex>}
  </Flex>

</Box>)
}
